import { Component, OnInit, Input } from '@angular/core';
import { MinisterService } from '@asambleas-services/minister/minister.service';
import { environment } from '@asambleas-env/environment';

@Component({
  selector: 'app-minister-files',
  templateUrl: './minister-files.component.html',
  styleUrls: ['./minister-files.component.scss']
})
export class MinisterFilesComponent implements OnInit {
  @Input('id') id: number;

  files: string[] = [];

  constructor(private ministerService: MinisterService) { }

  ngOnInit() {
    this.ministerService.getFilesMinisterPostulation(this.id)
      .subscribe((data: string[]) => {
        this.files = data;
      })
  }

  getUrlFile(name: string) {

    let nameArray = name.split('.');

    let url = environment.apiEndPoint + '/ministros/' + this.id + '/get-file-postulation/' + nameArray[0] + '/' + nameArray[1];

    return url;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/minister-files/minister-files.component.ts